import React, { useEffect, useState } from 'react'
import { IconPlusBg } from '../../../../../../../../../../shared/IconsComponent/icons'
import AddNewFunctionalStatus from './AddNewFunctionalStatus';
import { enumUtil } from '../../../../../../../../../../../utils/Enum';
import { ServerRequestProtected } from '../../../../../../../../../../../utils/ServerDataRequest';

const FunctionalStatus = (props) => {
    let { setSaveFunctionalStatusData, functionalStatusData, setObservationsData } = props;
    const API_URL = enumUtil.controller.General

    const [isOpenFunctionalStatus, setIsOpenFunctionalStatus] = useState(false);
    const [functionalStatusID, setFunctionalStatusID] = useState();
    let FunctionalStatus_Modal = {
        FunctionalStatusValuesID: "",
        FunctionalStatusValues: "",
        FunctionalDate: "",
        Notes:  ""
    }
    const [mainFunctionalStatusModal, setMainFunctionalStatusModal] = useState(FunctionalStatus_Modal);
    const [functionalStatusDDData, setFunctionalStatusDDData] = useState([]);

    useEffect(() => {
      ServerRequestProtected(API_URL + "/DropDown", 'post', {
        "TableName": enumUtil.enumAPITableName.FUNCTIONALSTATUS,
      }).then((response) => {
        setFunctionalStatusDDData(response);
      }).catch((error) => {
      })
    }, [])

    const AddFunctionalStatus = (ID, prob) => {
        setFunctionalStatusID(ID)
        setMainFunctionalStatusModal(prob);
        setIsOpenFunctionalStatus(prev => !prev);
    }
    const CloseFunctionalStatus = () => {
        setIsOpenFunctionalStatus(false)
        setMainFunctionalStatusModal(FunctionalStatus_Modal);
        setFunctionalStatusID();
    }
    
    const handleFunctionalDelete = (item, indexToRemove) => {
        const { FunctionalStatusID, recordNoClient } = item;

        // 1. Remove from ObservationsData (view state)
        setObservationsData(prev => {
            const updatedFunctionalStatus = prev.FunctionalStatus.filter((_, idx) => idx !== indexToRemove);
            return { ...prev, FunctionalStatus: updatedFunctionalStatus };
        });

        // 2. Update saveFunctionalStatusData (save state)
        setSaveFunctionalStatusData(prev => {
            if (FunctionalStatusID) {
                const exists = prev.some(cs => cs.FunctionalStatusID === FunctionalStatusID);

                if (exists) {
                    // Already in save state → mark as deleted
                    return prev.map(cs =>
                        cs.FunctionalStatusID === FunctionalStatusID
                            ? { ...cs, Deleted: "true" }
                            : cs
                    );
                } else {
                    // Not in save state yet → add a deleted entry
                    return [
                        ...prev,
                        {
                            FunctionalStatusID,
                            EncounterID: item.EncounterID,
                            Deleted: "true",
                        },
                    ];
                }
            } else if (recordNoClient) {
                // Local-only entry → remove it completely
                return prev.filter(cs => cs.recordNoClient !== recordNoClient);
            } else {
                return prev;
            }
        });
    };

    let PopupScreen = "";
    if (isOpenFunctionalStatus) {
        PopupScreen = 
        <AddNewFunctionalStatus 
            isOpenFunctionalStatus={isOpenFunctionalStatus} 
            functionalStatusID={functionalStatusID}
            onClose={CloseFunctionalStatus} 
            setObservationsData={setObservationsData}
            FunctionalStatus_Modal={FunctionalStatus_Modal}
            mainFunctionalStatusModal={mainFunctionalStatusModal} setMainFunctionalStatusModal={setMainFunctionalStatusModal}
            setSaveFunctionalStatusData={setSaveFunctionalStatusData}
            functionalStatusDDData={functionalStatusDDData}
            // onDeleteFunctionalStatus={DeleteFunctionalStatus} 
            // setIsRecordSaved={setIsRecordSaved}
        />
    }
    console.log("saveCogntiveStatusData functionalStatusData functionalStatusData",functionalStatusData)
  return (
        <div className="">
            {PopupScreen}
            <div className="d-flex align-items-center gap-2 mb-2 px-1-5">
                <p className="heading">Functional Status</p>
                <div onClick={() => AddFunctionalStatus(null, FunctionalStatus_Modal)}><IconPlusBg /></div>
            </div>
            <div className="d-flex flex-column gap-2 ar_content hover-scrollbar px-1-5">
                {functionalStatusData?.length > 0 ? 
                    (functionalStatusData.map((functionalStatusItem, index)=> {
                        let display  = functionalStatusItem?.FunctionalStatusValues?.split("-").map(part => part.trim());
                    return (
                    <div className="d-flex align-items-center justify-content-between">
                        <div className='d-flex align-items-center gap-1'>
                            <p className='text'>
                                <span className='validate-color cursor-pointer' onClick={() => AddFunctionalStatus(functionalStatusItem.FunctionalStatusValuesID, functionalStatusItem)}>
                                {display?.[1] || 'N/A'}</span> - {display?.[0] || 'N/A'} 
                            </p>
                            <span className='text light-clrs'>|</span>
                            <p className='text'><span className='font-m'>Date:</span> {functionalStatusItem.FunctionalDate}</p>
                        </div>
                        <i className='icon-x-cros fs-20 dark-clr' onClick={() => handleFunctionalDelete(functionalStatusItem, index)}></i>
                    </div>)
                })) :
                (<div className="d-flex flex-column gap-2 ar_content hover-scrollbar px-1-5">
                    <p className='text light-clrs'>No functional status recorded</p>
                </div>)}
                {/* <div className="d-flex align-items-center justify-content-between">
                    <div className='d-flex align-items-center gap-1'>
                        <p className='text'><span className='validate-color'>Hysterical Annesia</span> - 923824    </p>
                        <span className='text light-clrs'>|</span>
                        <p className='text'><span className='font-m'>Date:</span> 8/5/2025</p>
                    </div>
                    <i className='icon-x-cros fs-20 dark-clr'></i>
                </div> */}
            </div>
        </div>
  )
}

export default FunctionalStatus


    // const handleDocumentDelete = (item, indexToRemove) => {
    //     const { PatientDocumentID, recordNoClient } = item;

    //     // Remove from EncounterDocument list by index
    //     setAdditionalInfoData(prev => {
    //         const updatedEncounterDocument = prev.EncounterDocument.filter((_, idx) => idx !== indexToRemove);
    //         return { ...prev, EncounterDocument: updatedEncounterDocument };
    //     });
    //     // Update saveDocumentData accordingly
    //     setSaveDocumentData(prev => {
    //         if (PatientDocumentID) {
    //             const exists = prev.some(doc => doc.PatientDocumentID === PatientDocumentID);

    //             if (exists) {
    //                 //  Update it to mark as deleted
    //                 return prev.map(doc =>
    //                     doc.PatientDocumentID === PatientDocumentID
    //                         ? { ...doc, Deleted: "true" }
    //                         : doc
    //                 );
    //             } else {
    //                 //  Push a new deleted object if it doesn't exist yet
    //                 return [
    //                     ...prev,
    //                     {
    //                         PatientDocumentID,
    //                         EncounterID: item.EncounterID,
    //                         Deleted: "true",
    //                     },
    //                 ];
    //             }
    //         } else if (recordNoClient) {
    //             //  Remove unsaved local doc entirely
    //             return prev.filter(doc => doc.recordNoClient !== recordNoClient);
    //         } else {
    //             return prev;
    //         }
    //     });
    // }
